import {Validators} from '@angular/forms';

import {ClientStatusTriggersEnum} from '@spa/api';

import {InArrayValidator} from '@spa/validators';

import {BaseControl, Helper, RadioGroupControl} from '../../../app/shared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components/dialog';

export const ChangeClientStatusSelector = 'clientStatus';
export const ChangeClientStatusMessageSelector = 'clientMessage';

export const ClientStatusesComponentControls = (): BaseControl [] => {
    return [
        new RadioGroupControl({
            name: ChangeClientStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [
                Validators.required,

                InArrayValidator([
                    ClientStatusTriggersEnum.PendingAcceptance,
                    ClientStatusTriggersEnum.ForVerification,
                    ClientStatusTriggersEnum.PutOnHold,
                    ClientStatusTriggersEnum.Verify,
                    ClientStatusTriggersEnum.Block,
                    ClientStatusTriggersEnum.Activate,
                    ClientStatusTriggersEnum.Terminate,
                    ClientStatusTriggersEnum.Decline
                ])
            ],
            componentType: ComponentTypesEnum.RadioGroup,
            invalid: false,
            errors: [],
            options: [
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.PendingAcceptance),
                    value: ClientStatusTriggersEnum.PendingAcceptance,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.ForVerification),
                    value: ClientStatusTriggersEnum.ForVerification,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.PutOnHold),
                    value: ClientStatusTriggersEnum.PutOnHold,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Verify),
                    value: ClientStatusTriggersEnum.Verify,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Block),
                    value: ClientStatusTriggersEnum.Block,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Activate),
                    value: ClientStatusTriggersEnum.Activate,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Terminate),
                    value: ClientStatusTriggersEnum.Terminate,
                    color: ColorCodesEnum.Primary
                },
                {
                    label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Decline),
                    value: ClientStatusTriggersEnum.Decline,
                    color: ColorCodesEnum.Primary
                }
            ]
        }),
        new BaseControl({
            name: ChangeClientStatusMessageSelector,
            value: null,
            placeholder: 'Message',
            validators: [],
            componentType: ComponentTypesEnum.Text
        })
    ];
};


export const ChangeClientStatusDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Save
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
